import React from "react"

const collectionCss = {
  listStyleType: "none",
  padding: 0,
  margin: 0,
}

const collectionItemCss = theme => ({
  display: "flex",
  alignItems: "center",
  padding: 0,
  marginBottom: theme[2],

  "&:last-of-type": {
    marginBottom: 0,
  },
})

export function Collection({ children, as: Root = "ul" }) {
  return <Root css={collectionCss}>{children}</Root>
}

export function CollectionItem({ children, Icon }) {
  return (
    <li css={collectionItemCss}>
      {Icon}
      {children}
    </li>
  )
}
